import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { PlatformPortalApiService } from './platform-portal-api.service';
import { OwnershipEntry } from '../models/ownership-entry';
import { TeamOwnerMinorEntry } from '../models/team-owner-minor-entry';

@Injectable({
  providedIn: 'root'
})
export class OwnershipService {
    private readonly repoOwnershipMasterCache = new Map<string, Observable<OwnershipEntry[]>>();
    private readonly teamOwnerMinorCache = new Map<string, Observable<TeamOwnerMinorEntry[]>>();

    constructor(private readonly platformPortalApiService: PlatformPortalApiService) {}

    getRepoOwnershipMaster(org: string): Observable<OwnershipEntry[]> {
        if (!this.repoOwnershipMasterCache.has(org)) {
            const ownership$ = this.platformPortalApiService.getOwnership<OwnershipEntry[]>(org, 'RepoOwnershipMaster.json').pipe(
                shareReplay(1)
            );
            this.repoOwnershipMasterCache.set(org, ownership$);
        }
        return this.repoOwnershipMasterCache.get(org)!;
    }

    getTeamOwnerMinor(org: string): Observable<TeamOwnerMinorEntry[]> {
        if (!this.teamOwnerMinorCache.has(org)) {
            const teamOwner$ = this.platformPortalApiService.getOwnership<TeamOwnerMinorEntry[]>(org, 'TeamOwnerMinor.json').pipe(
                shareReplay(1)
            );
            this.teamOwnerMinorCache.set(org, teamOwner$);
        }
        return this.teamOwnerMinorCache.get(org)!;
    }
}